export default {
  viewBase: {
    'a1': '健康动态',
    'a2': '取消',
    'a3': '删除',
    'a4': '添加家人，关注家人健康',
    'a5': 'HRV心脏指数',
    'a6': '未测量',
    'a7': '呼吸暂停次数',
    'a8': '次',
    'a9': '呼吸暂停',
    'a10': 'hrv',
    'a11': '血糖',
    'a12': '心率',
    'a13': '心电',
    'a14': '心脏负荷',
    'a15': '血氧',
    'a16': '动脉硬化指数',
    'a17': 'sos预警',
    'a18': '健康分析',
    'a19': '血压',
    'a20': '正常',
    'a21': '偏高',
    'a22': '偏低',
    'a23': 'BMI',
    'a24': '运动',
    'a25': '删除成功',
    'a26': '删除失败',
    'a27': '您没有可以编辑的家人',
    'a28': '选择家人关系',
    'a29': '家人关系',
    'a30': '请输入手机号码',
    'a31': '手机号码',
    'a32': '立即绑定',
    'a33': '男',
    'a34': '女',
    'a35': '家人关系未选择',
    'a36': '手机号格式错误',
    'a37': '绑定成功',
    'a38': '拒绝',
    'a39': '同意',
    'a40': '已添加',
    'a41': '已拒绝',
    'a42': '确定删除吗？',
    'a43': '加载中...',
    'a44': '确定拒绝家人关系吗？',
    'a45': '确定同意家人关系吗？',
    'a46': '已经到底了',
    'a47': '暂无数据',
    'a48': '周',
    'a49': '月',
    'a50': '开始时间',
    'a51': '结束时间',
    'a52': '趋势统计',
    'a53': '数据分析',
    'a54': '项目',
    'a55': '本周',
    'a56': '本月',
    'a57': '上周',
    'a58': '上月',
    'a59': '总测量（次）',
    'a60': '正常（次）',
    'a61': '异常（次）',
    'a62': '平均数值',
    'a63': '最高值',
    'a64': '最低值',
    'a65': '步',
    'a66': '保存',
    'a67': '头像',
    'a68': '姓名',
    'a69': '请输入姓名',
    'a70': '脏音',
    'a71': '选择性别',
    'a72': '请选择',
    'a73': '请输入详细地址',
    'a74': '姓名未填写',
    'a75': '性别未选择',
    'a76': '出生日期未选择',
    'a77': '成功',
    'a78': '详细地址',
    'a79': '性别',
    'a80': '出生日期',
    'a81': '确定',
    'a82': '经度',
    'a83': '纬度',
    'a84': '总（次）',
    'a85': '平均',
    'a86': '高值',
    'a87': '低值',
    'a88': '正常',
    'a89': '异常',
    'a90': '时间查询',
    'a91': '步数',
    'a92': '手动录入',
    'a93': '请输入步数',
    'a94': '处理失败，请重试'
  }
}

